import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Parse } from "parse";
import { Link } from "react-router-dom";
import { FacebookShareButton, EmailShareButton } from "react-share";
import "../style.less";
import MainHeader from "../Header/header";
import MyFooter from "../Footer/footer";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer";
import ProfilPro from "./profil_pro";
import ProfilBasic from "./profil_basic";
import ModalSignOut from "./modalsignout";
import ModalPassword from "./modalpassword";

//import ModalDelete from './modaldelete'
import { ColShadow, Contentstyled, Layoutstyled } from "../Constants/style";
import { Divider, Icon, message, Row } from "antd";
import moment from "moment";
import "moment/locale/fr";
import { getAvatar } from "../Constants/functions";
moment.locale("fr");
Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      nickName: "",
      createdAt: "",
      attributes: Parse.User.current().attributes
    };
  }

  chooseProfil() {
    return this.state.attributes.professional ? <ProfilPro /> : <ProfilBasic />;
  }

  async componentDidMount() {
    try {
      this.currentUser = await Parse.User.current().fetch();
      if (this.currentUser === null || this.currentUser === undefined) {
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
      if (this.currentUser.attributes !== undefined) {
        this.setState({ attributes: this.currentUser.attributes });
      }
    } catch (error) {
      console.log("error : ", error);
      if (error.code === 209 || error.message === "invalid session token") {
        console.log("invalid session token");
        this.props.userDisconnected();
        this.setState({ redirectToHomePage: true });
        return message.warn("Ta session a expiré, reconnecte-toi !");
      }
    }
  }

  getInfosAbo() {
    if (this.state.attributes.professional === true) {
      if (this.state.attributes.expirationAbo !== undefined) {
        return (
          <div>
            {" "}
            Licence valable jusqu'au{" "}
            {moment(this.state.attributes.expirationAbo).format(
              "DD MMMM YYYY"
            )}{" "}
          </div>
        );
      } else
        return "Pas de licence en cours, rends-toi sur la page Achat pour pouvoir exercer.";
    } else {
      if (
        this.state.attributes.expirationAbo !== undefined &&
        this.state.attributes.coursParticulier !== undefined
      ) {
        return (
          <div>
            <Row>
              {" "}
              Abonnement valable jusqu'au{" "}
              {moment(this.state.attributes.expirationAbo).format(
                "DD MMMM YYYY"
              )}{" "}
            </Row>
            <Row>
              {" "}
              {this.state.attributes.coursParticulier} cours individuels
              restants{" "}
            </Row>
          </div>
        );
      } else if (
        this.state.attributes.expirationAbo &&
        !this.state.attributes.coursParticulier
      ) {
        return (
          <div>
            <Row>
              {" "}
              Abonnement valable jusqu'au{" "}
              {moment(this.state.attributes.expirationAbo).format(
                "DD MMMM YYYY"
              )}{" "}
            </Row>
            <Row> Pas de cours individuels restants </Row>
          </div>
        );
      } else
        return (
          <div>
            <Row> Pas d'abonnement en cours </Row>
            <Row> Pas de cours individuel restants </Row>
          </div>
        );
    }
  }

  getInfosFidelite() {
    if (!this.state.attributes.ptsFidelity) {
      return null;
    } else {
      return (
        <Row>
          Vous avez accumulé {this.state.attributes.ptsFidelity} points de
          fidelité.
        </Row>
      );
    }
  }
  onShareFB = async () => {
    let newShare = await Parse.Cloud.run("checkShareFacebook");
    if(!newShare) return;

    let fidelity = new Parse.Object("Fidelity");
    this.currentUser.increment("ptsFidelity", 50);
    fidelity.set("user", this.currentUser);
    fidelity.set("action", "partage facebook");
    fidelity.set(
      "description",
      "Tu as partagé et invité des amis à rejoindre Urban Fitness via Facebook !"
    );
    fidelity.set("amount", 50);
    this.currentUser.save();
    return fidelity.save();
  };

  onShareMail = async () => {
    let newShare = await Parse.Cloud.run("checkShareMail");
    if(!newShare) return;
    let fidelity = new Parse.Object("Fidelity");
    this.currentUser.increment("ptsFidelity", 100);
    fidelity.set("user", this.currentUser);
    fidelity.set("action", "partage email");
    fidelity.set(
      "description",
      "Tu as partagé et invité des amis à rejoindre Urban Fitness par email !"
    );
    fidelity.set("amount", 100);
    this.currentUser.save();
    return fidelity.save();
  };

  render() {
    if (this.state.redirectToHomePage === true) {
      console.log("on va redirect ?");
      //this.props.showModal();
      return <Redirect to="/" />;
    }

    let url = "https://urbanfitnessfrance.netlify.com";

    return (
      <Layoutstyled>
        <MainHeader />
        <HeaderContainer />
        <Contentstyled>
          <Row type="flex" justify="center" align="top">
            <ColShadow
              style={{
                background: "#fff",
                padding: 24,
                radius: 4,
                marginBottom: 35
              }}
              xs={24}
              sm={24}
              md={24}
              lg={6}
              xl={5}
            >
              <img
                src={getAvatar(this.state.attributes)}
                width="128px"
                height="128px"
                alt="profil"
                style={{
                  margin: "15px auto",
                  display: "block",
                  border: "1px solid"
                }}
              />
              <div
                style={{
                  fontWeight: 700,
                  paddingTop: "1vh",
                  textAlign: "center"
                }}
              >
                {" "}
                {this.state.attributes.firstName}{" "}
                {this.state.attributes.lastName} (
                {this.state.attributes.nickName})
              </div>
              <div
                style={{
                  fontSize: "12px",
                  paddingTop: "1vh",
                  fontStyle: "italic",
                  //marginBottom: "20px",
                  textAlign: "center"
                }}
              >
                {" "}
                {this.getInfosAbo()}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  paddingTop: "20px",
                  fontStyle: "italic",
                  //  marginBottom: "20px",
                  textAlign: "center"
                }}
              >
                {this.getInfosFidelite()}
              </div>
              <Divider />
              {
                <Link to="/settings">
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "#0000FE",
                      cursor: "pointer"
                    }}
                  >
                    <Icon type="user" theme="outlined" />
                    {""} Modifier mon profil
                  </span>
                </Link>
              }
              <ModalPassword />
              <Divider />
              <FacebookShareButton
                url={url}
                onShareWindowClose={this.onShareFB}
                quote={`Hey, rejoins comme moi la #TEAMURBAN et atteins ton objectif. Merci URBAN FITNESS FRANCE`}
              >
                {" "}
                <p style={{ fontSize: 12, color: "#0000FE"}}>
                <Icon
                  type="facebook"
                  className="icon-center"
                />{" "}
                Partager sur Facebook
                </p>
              </FacebookShareButton>{" "}
              <EmailShareButton
                url={url}
                beforeOnClick={this.onShareMail}
                subject={"Viens faire du sport avec moi !"}
                body={`Coucou, fais comme moi, atteins ton objectif avec la #TEAMURBAN.
                  Viens découvrir une nouvelle manière de faire du sport. Inscris-toi et rejoins moi sur le site ${url} en mentionnant mon Nom/Prénom dans la case parrainage, tu recevras un mail pour tester une séance offerte. À très bientôt.
                  ${url} `}
              >
                {" "}
                <p style={{ fontSize: 12, color: "#0000FE"}}>
                <Icon
                  type="mail"
                  className="icon-center"
                />{" "}
                Partager par Email
                </p>
              </EmailShareButton>
              <Divider />
              <ModalSignOut />
            </ColShadow>
            <ColShadow
              style={{ background: "#fff", padding: 24, radius: 10 }}
              xs={24}
              sm={24}
              md={24}
              lg={{ span: 16, offset: 1 }}
              xl={{ span: 17, offset: 1 }}
            >
              <h3>Mon Profil</h3>
              <Divider style={{ background: "#0000FE" }} className="short" />
              {this.chooseProfil()}
            </ColShadow>
          </Row>
        </Contentstyled>
        <MyFooter />
      </Layoutstyled>
    );
  }
}
/*

*/

const mapStateToProps = globalReducers => globalReducers;
const mapDispatchToProps = dispatch => {
  return {
    userDisconnected() {
      dispatch({ type: "disconnect" });
    }
  };
};

const connectedProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);
export default connectedProfile;
